import _ from 'lodash';

class TNTBillingController {
  /*@ngInject*/
  constructor(Auth, $state, User, UserService, $translate, $location, Modal, DataCounter, $q, HoldService, HoldLocationService, $rootScope) {

    this.$state = $state

    this.$translate = $translate;
    this.Auth = Auth;
    this.$state = $state;
    this.User = User;
    this.$q = $q;
    this.$location = $location;
    this.HoldLocationService = HoldLocationService;
    this.HoldService = HoldService;
    this.Modal = Modal;
    this.DataCounter = DataCounter
    this.holdServiceData = []
    this.itemHoldServiceData = []
    this.$rootScope = $rootScope
    this.currentBranch = User.getUser().branchId
    this.tabConfig = {
      'tnt_billing_billable_events': {
        title: 'billableEvents.menu.title',
        state: 'billable_events',
      },
      'tnt_billing_billing_category': {
        title: 'billingCategory.menu.title',
        state: 'billing_category',
      },
      'tnt_billing_contract': {
        title: 'contract.contract',
        state: 'contract'
      },
      'tnt_billing_contract_type': {
        title: 'contractType.menu.title',
        state: 'contract_type'
      },
      'tnt_billing_customer': {
        title: 'Customer',
        state: 'customer'
      },
      'tnt_billing_location_distance': {
        title: 'locationDistance.menu.title',
        state: 'location_distance',
      },
      'tnt_billing_fuel_surcharges': {
        title: 'common.side_menu.fuel_surcharges',
        state: 'fuel_surcharges'
      }
    };
    this.acl = User.getACL('tntBilling')
    // this.hasACL = {}
    this.tabs = [];
    // this.$rootScope.$broadcast('routeChange', null);
  }

  // loadPermission() {
  //   this.acl = {};
  //   this.hasACL = {};

  //   [
  //     'tnt_billing',
  //     'tnt_billing_billable_events',
  //     'tnt_billing_billing_category',
  //     'tnt_billing_contract',
  //     'tnt_billing_customer',
  //   ].forEach((permissionKey) => {
  //     this.acl[permissionKey] = this.User.getACL(permissionKey)

  //     this.hasACL[permissionKey] = {};
  //     if (this.acl[permissionKey] && this.acl[permissionKey].length > 0) {
  //       this.acl[permissionKey].forEach((permission) => {
  //         this.hasACL[permissionKey][permission] = true;
  //       });
  //     }
  //   });
  // }


  getStateDiff(array) {
    let diff = []
    let index = 0
    for (let i = 0; i < array.length; i++) {
      let key = array[i];
      if (!(key in this.acl)) {
        diff[index++] = array[i]
      }
    }
    return diff
  }

  $onInit() {
    let toDeregister = this.getStateDiff(Object.keys(this.tabConfig))
    for (let i = 0; i < toDeregister.length; i++) {
      if (this.$state.get(toDeregister[i])) {
        this.$state.router.stateRegistry.deregister(toDeregister[i])
      }
    }
    // for (let key in Object.keys(this.tabConfig)) {
      _.forEach(Object.keys(this.tabConfig), (key, i) => {
      if (this.acl[key] && this.acl[key].indexOf('view') >= 0) {
        let tabConfig = this.tabConfig[key];
        if (tabConfig) {
          let obj = Object.assign(tabConfig, { key })
          this.tabs.push(obj);
        }
      }
    })
    if (this.$state.current.name == 'tntBilling' && this.tabs.length) {
      this.$state.go(this.tabs[0].state)
    }

    this.$rootScope.$broadcast('routeChange', null);
    // });
    // // by default select the first available tab if user has just entered this page
    // const currentUrl = this.$location.url();
    // if (currentUrl.endsWith('/tnt-billing') && this.tabs && this.tabs.length) {
    //   this.$state.go(this.tabs[0].state);
    //   this.$rootScope.$broadcast('routeChange', null);
    // }
  }

  hasAcl(key) {
    if (this.acl[key] && this.acl[key].indexOf('view') >= 0) {
      return true;
    } else {
      return false;
    }
  }
}

export default TNTBillingController;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/tnt_billing.controller.js